/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For more information visit: https://egtuniverse.com/legal
 *
 * Created for Universe App Tools.
 *
 * Created by Justin K Kazmierczak.
 */

/*
 * email.unsubscribe — the MARKETING footer add-on (layered on top of email.footer).
 *
 * Renders the CAN-SPAM "why am I getting this" reason line + a link to the
 * subscription PREFERENCE CENTRE ("Modify subscription or unsubscribe" — the
 * landing page lets the recipient turn individual newsletters on/off as well as
 * opt out of everything), and (only when configured) the required physical
 * postal address.
 *
 * The link href is the LITERAL placeholder `${unsubUrl}`. It is intentionally
 * NOT resolved here: the sending engine rewrites it, per recipient, to a tracked
 * `/go/<guid>` link at send time. This element builds NO tracking of its own.
 *
 * The physical address is read from config `email.canspam.address` and is emitted
 * ONLY when non-empty. EGT has no postal address today, so the address line is
 * omitted; the day a PO Box / CMRA box is added to config, it appears with no code
 * change. (The marketing send path — not this element — is what fails closed on an
 * empty address before a commercial blast.)
 */
var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "email.unsubscribe",
    title: "Email Unsubscribe",
    description: "Marketing footer add-on: CAN-SPAM reason line, a 'Modify subscription or unsubscribe' preference-centre link (placeholder rewritten at send), and the physical address when configured.",
    supportServer: true,
    control: false,
    foruseIn: ["email"],
    fields: {}
});

var $ = require("../../../uam/scafolding.js");

// The literal placeholder the sending engine rewrites, per recipient, to a
// tracked /go/<guid> URL. Kept as a constant so the contract is unmistakable.
var UNSUB_PLACEHOLDER = "${unsubUrl}";

exports.render = async function (options) {
    var { html } = await exports.renderEmail(options);
    return [{
        n: "ua.element.serverNotSupported",
        inner: {
            n: "json",
            type: "ua/interface",
            by: "email.unsubscribe",
            i: JSON.stringify({
                n: "html",
                html: `<div style="max-width:480px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;">${html}</div>`
            })
        }
    }];
};

exports.renderEmail = async function (options) {
    var cfg = $.config || {};
    var appName = (cfg.my && cfg.my.app && cfg.my.app.name) ? cfg.my.app.name : "The Universe";

    // Physical postal address — ONLY emitted when configured (non-empty).
    var address = "";
    if (cfg.email && cfg.email.canspam && typeof cfg.email.canspam.address === "string") {
        address = cfg.email.canspam.address.trim();
    }

    var reasonHtml = `<p style="margin:0 0 8px 0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#6C757D;">
      You're receiving this email because you subscribed to updates from ${appName}.
      <a href="${UNSUB_PLACEHOLDER}" style="color:#6C757D;text-decoration:underline;">Modify subscription or unsubscribe</a>.
    </p>`;

    var addressHtml = address
        ? `<p style="margin:0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#6C757D;">${address}</p>`
        : "";

    var html = `<tr>
  <td style="padding:0 20px 20px 20px;">
    <table width="100%" border="0" cellpadding="0" cellspacing="0">
      <tr>
        <td style="padding:0;text-align:center;">
          ${reasonHtml}
          ${addressHtml}
        </td>
      </tr>
    </table>
  </td>
</tr>`;

    var textParts = [
        "You're receiving this email because you subscribed to updates from " + appName + ".",
        "Modify subscription or unsubscribe: " + UNSUB_PLACEHOLDER
    ];
    if (address) { textParts.push(address); }
    var text = textParts.join("\n");

    return { html, text };
};
